function checkIsFormWxapp() {
    let i = localStorage.getItem('app-from');
    return i === 'product_wxapp';
}

function loadAppForm() {
    let search = location.search;
    if (search.indexOf('_from') !== -1 && search.indexOf('product_wxapp') !== -1) {
        localStorage.setItem('app-from', 'product_wxapp');
    }else{
        localStorage.setItem('app-from', '');
    }
    return true;
}

export {
    checkIsFormWxapp,
    loadAppForm
}


// WEBPACK FOOTER //
// ./src/utils/wxapp-check.js